import { Type } from "@sinclair/typebox";
import SchemaValidator from "../schema-validator";

const lms = new SchemaValidator(
	Type.Union([
		Type.Literal("canvas"),
		Type.Literal("moodle"),
		Type.Literal("BlackboardLearn"),
		Type.Literal("desire2learn"),
	]),
);

const assessmentInfo = new SchemaValidator(
	Type.Object({
		lms: lms.schema,
		hostname: Type.String(),
		courseId: Type.Optional(Type.String()),
		quizId: Type.String(),
		quizInfo: Type.Optional(Type.Record(Type.String(), Type.Any())),
		quizOther: Type.Optional(Type.Record(Type.String(), Type.Any())),
	}),
);

const deleteAssessmentInfo = new SchemaValidator(
	Type.Object({
		id: Type.Number(),
		courseId: Type.Number(),
		quizId: Type.String(),
		quizInfo: Type.Optional(Type.Record(Type.String(), Type.Any())),
		other: Type.Optional(Type.Record(Type.String(), Type.Any())),
		isDeleted: Type.Boolean(),
		createdAt: Type.String(),
		updatedAt: Type.String(),
	}),
);

const assessmentInfoAlternate = new SchemaValidator(
	Type.Object({
		lms: lms.schema,
		hostname: Type.String(),
		lmsProvidedCourseId: Type.Optional(Type.String()),
		lmsProvidedAssessmentId: Type.String(),
	}),
);

const url = new SchemaValidator(Type.String());

const instituteLmsInfo = new SchemaValidator(
	Type.Object({
		id: Type.Number(),
		instituteName: Type.Union([Type.Null(), Type.String()]),
		origin: Type.Optional(Type.Union([Type.Null(), Type.String()])),
		lmsApiClientId: Type.Optional(Type.Union([Type.Null(), Type.String()])),
	}),
);

const tokenExists = new SchemaValidator(
	Type.Object({
		exists: Type.Boolean(),
	}),
);

const tokenTestResults = new SchemaValidator(
	Type.Array(
		Type.Object({
			key: Type.String(),
			relativePath: Type.String(),
			requestType: Type.String(),
			status: Type.String(),
		}),
	),
);

const deleteResponse = new SchemaValidator(
	Type.Object({
		success: Type.Boolean(),
		lmsResponse: Type.Optional(Type.Unknown()),
	}),
);

export default {
	lms,
	assessmentInfo,
	url,
	instituteLmsInfo,
	tokenExists,
	tokenTestResults,
	deleteResponse,
	assessmentInfoAlternate,
	deleteAssessmentInfo,
};
